module.exports = __webpack_public_path__ + "static/media/0110_IMG_LA_COQUE.69b5fdda.png";